import { graphql, PageProps } from "gatsby"
import React from "react"
import { Blocks } from "../blocks"
import { Layout } from "../components"

const PageTemplate = ({ data }: PageProps<PageQueryResult>) => {
  const { title, metaDescription, blocks } = data.sanityPage
  // If the first block is a Hero, remove the paddingTop of the Layout component
  const removeTopPadding = blocks[0]?.__typename === "SanityHero"
  return (
    <Layout {...{ title, metaDescription, removeTopPadding }}>
      <Blocks {...{ blocks }} />
    </Layout>
  )
}

type PageQueryResult = {
  sanityPage: {
    title: string
    metaDescription: string
    blocks: any[]
  }
}

export const query = graphql`
  query PageTemplateQuery($id: String) {
    sanityPage(_id: { eq: $id }) {
      title
      metaDescription
      ...PageBlocks
    }
  }
`

export default PageTemplate
